<div class="card flex justify-center">
  <p-drawer #drawerRef [(visible)]="visible" [closable]="closable" [dismissible]="true" [blockScroll]="blockScroll" (onHide)="visibleChange.emit(false)"
    styleClass="w-full sm:w-23rem">
    <ng-template #headless>
      <div class="flex flex-column h-full overflow-auto" pFocusTrap>
        <div class="cross py-3 px-4 border-bottom-1 border-slate-200" (click)="closeCallback()">
          <i class="pi pi-times border-circle border-1 p-2 border-slate-200 text-slate-800 cursor-pointer" tabindex="0" (keydown.enter)="closeCallback()"
          role="button" aria-label="Close menu" (keydown.space)="closeCallback()"></i>
        </div>
        <div *ngIf="promoslotVisible"
          class="navigationslot m-4 p-4 flex justify-content-center align-items-center border-1 border-round border-dashed border-purple-600">
          <span class="text-purple-600 text-base font-outfit font-normal">Navigation promo slot</span>
        </div>
        <div *ngIf="items && items.length > 0" class="menulist p-4">

          <p-menu [model]="items" styleClass="border-none" ariaLabel="Menu">
            <ng-template #item let-item>
              <ng-container *ngIf="item.route; else elseBlock">
                <a [routerLink]="item.route" routerLinkActive="bg-blue-50 border-round-md" #rla="routerLinkActive"
                  [routerLinkActiveOptions]="{ exact: true }" class="p-menu-item-link p-3" (click)="closeItem(item.route)" (keydown.enter)="navigateToURL(item.route)">
                  <span class="text-base" [class.text-blue-600]="rla.isActive" [class.text-slate-500]="!rla.isActive"
                    [class]="item.icon"></span> 
                  <span class="ml-2 font-normal font-outfit text-base" [class.text-blue-600]="rla.isActive"
                    [class.text-slate-800]="!rla.isActive">{{
                    item.label }}</span>
                </a>
              </ng-container>
              <ng-template #elseBlock>
                <a [href]="item.url" class="p-menu-item-link p-3">
                  <span class="text-base text-slate-500" [class]="item.icon"></span>
                  <span class="ml-2 font-normal font-outfit text-base text-slate-800">{{ item.label
                    }}</span>
                </a>
              </ng-template>
            </ng-template>
          </p-menu>
        </div>
        <div *ngIf="requestServiceEnable" class="border-top-1 border-slate-200">
          <div class="flex w-full p-4">
            <p-button [rounded]="true" label="Request service" (click)="navigateToServiceRequest()" severity="primary" data-auto-id="request-service"
              class="flex align-items-center justify-content-center w-full" styleClass="w-full"></p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-drawer>
</div>